export const num2name = {
    0: "ERROR_UNSPECIFIED",
    1: "ERROR_SUBSCRIPTION_PRODUCT_BOARD_DOES_NOT_EXIST",
};
export const name2num = {
    ERROR_UNSPECIFIED: 0,
    ERROR_SUBSCRIPTION_PRODUCT_BOARD_DOES_NOT_EXIST: 1,
};
